import { Box, Checkbox, FormControl, ListItemText, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Modal, Snackbar, Alert, IconButton, Autocomplete, TextField } from '@mui/material';
import React, { Component } from 'react'
import { GridTable } from '../Sidebar/SidebarStyles';
import { GridColDef } from '@mui/x-data-grid';
import { fetchAllUsers, fetchMenuControls, saveRoleMenuControl, assignMenusForRole } from '../ApiSevices/UserMasterApis';
import { fetchRole } from '../ApiSevices/RoleMasterApis';
import EditIcon from "@mui/icons-material/Edit";

interface IProps {
    displaysidebar: boolean;
    allowedMenus: any[];
}

interface IState {
    loading: boolean;
    menuControlData: any[];
    roleOption: any[];
    userOption: any[];
    selectedRow: any;
    isModalOpen: boolean;
    roleDropdownOpen: boolean;
    userDropdownOpen: boolean;
    snackbarOpen: boolean;
    snackbarMessage: string;
    snackbarSeverity: 'success' | 'error' | 'info' | 'warning';
}

const columns: GridColDef[] = [
    { field: 'Menu', headerName: 'Menu Control', width: 200 },
    { field: 'role', headerName: 'Role', width: 300 },
    { field: 'user', headerName: 'User', width: 300 }
];

export default class MenuControls extends Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);
        this.state = {
            loading: false,
            menuControlData: [],
            roleOption: [],
            userOption: [],
            selectedRow: null,
            isModalOpen: false,
            roleDropdownOpen: false,
            userDropdownOpen: false,
            snackbarOpen: false,
            snackbarMessage: '',
            snackbarSeverity: 'success',
        }
    }

    componentDidMount(): void {
        this.getAllData();
    }

    componentDidUpdate(prevProps: IProps) {
        if (prevProps.allowedMenus !== this.props.allowedMenus) {
            this.getAllData();
        }
    }

    async getAllData() {
        const { allowedMenus } = this.props;

        try {
            this.setState({ loading: true });
            // const [Users, Roles] = await Promise.all([
            //     fetchAllUsers(),
            //     fetchRole(),
            // ]);
            const Roles = await fetchRole();
            const Users: any = {};

            const usersOptions = Users?.data?.map((e: any) => ({ label: e?.vchUser_Name, value: e?.ID }));
            const roleOptions = Roles?.map((e: any) => ({ label: e?.RoleName, value: e?.RoleId }));
            const filteredUser = usersOptions?.filter((e: any) => e?.label?.includes('@'))
                .sort((a: any, b: any) => a.label.localeCompare(b.label));

            const constructedMenuAry = allowedMenus?.map((row: any) => ({
                ...row,
                role: row?.RoleId ?
                    row?.RoleId?.split(',')?.map((id: string) => parseInt(id?.trim(), 10))
                    : [],

                user: row.UserId
                    ? row.UserId.split(',').map((u: string) => u.trim())
                    : []
            }));
            this.setState({
                menuControlData: constructedMenuAry,
                userOption: filteredUser,
                roleOption: roleOptions
            });
        } catch (error) {
            console.log(error);
        }
        finally {
            this.setState({ loading: false });
        }
    }

    handleChange = (event: any, row: any, column: string) => {
        const value = event.target.value;
        this.setState((prevState) => ({
            menuControlData: prevState.menuControlData?.map(e => {
                if (e.Id === row.Id) {
                    return { ...e, [column]: value }
                }
                return { ...e };
            })
        }));
    };

    async updateRoleForUser(): Promise<void> {
        const { menuControlData, loading } = this.state;
        const selectedData = menuControlData
            .filter(item => item.isSelected)
            .map(item => ({
                menu: item.Menu,
                role_ids: item.role,
                user_ids: item.user
            }));

        try {
            this.setState({ loading: true });
            const saveRes = await saveRoleMenuControl(selectedData);
            if (saveRes && selectedData) {
                selectedData?.forEach((res: any) => {
                    const matchedItem = menuControlData?.find(item => item?.Menu === res?.menu);
                    if (matchedItem) {
                        matchedItem.role = res.role_ids;
                        matchedItem.user = res.user_ids;
                        matchedItem.RoleId = res.role_ids?.join(',');
                        matchedItem.UserId = res.user_ids?.join(',');
                    }
                });
                this.showSnackbar('Role assigned successfully!', 'success');
            }
        } catch (error) {
            console.error("Error while saving role menu control", error);
        } finally {
            this.setState({ loading: false });
        }
    };

    showSnackbar = (message: string, severity: 'success' | 'error' | 'info' | 'warning') => {
        this.setState({ snackbarOpen: true, snackbarMessage: message, snackbarSeverity: severity });
    };

    handleCloseSnackbar = () => {
        this.setState({ snackbarOpen: false });
    };

    render() {
        const { loading, menuControlData, roleOption, userOption, selectedRow, isModalOpen, snackbarOpen, snackbarMessage, snackbarSeverity, } = this.state;
        return (
            <>
                <div style={{ fontSize: "12px" }}>
                    {loading && (
                        <Box sx={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: 'rgba(255, 255, 255, 0.5)',
                            zIndex: 9999
                        }}>
                            <div className="loader"></div>
                        </Box>
                    )}
                    {/* sx={{ height: '60vh' }} */}
                    <GridTable displaysidebar={this?.props?.displaysidebar}>
                        <p><b>Menu Control</b></p><br />
                        <div style={{ paddingTop: "10px", paddingRight: "5px" }}>
                            <Paper sx={{ width: '100%', mb: 2, overflow: 'hidden', border: '0.5px solid #7a6e6e54' }}>
                                <Box sx={{ maxHeight: 450, overflowX: 'auto' }}>
                                    <TableContainer sx={{ minWidth: 'max-content' }}>
                                        <Table stickyHeader sx={{ height: '50px' }} size="small">
                                            {/* Table Header */}
                                            <TableHead>
                                                <TableRow>
                                                    {columns?.map((column) => (
                                                        <TableCell
                                                            key={column.field}
                                                            sx={{
                                                                fontSize: '12px',
                                                                fontWeight: 'bold',
                                                                whiteSpace: 'nowrap',
                                                                backgroundColor: '#f5f5f5',
                                                                position: 'sticky',
                                                                top: 0,
                                                                zIndex: 1,
                                                                textAlign: 'center',
                                                                width: column.width
                                                            }}
                                                        >
                                                            {column.headerName}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell
                                                        sx={{
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            whiteSpace: 'nowrap',
                                                            backgroundColor: '#f5f5f5',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 1,
                                                            textAlign: 'center',
                                                            width: '200px'
                                                        }}
                                                    >
                                                        Actions
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                        </Table>

                                        <Box sx={{ maxHeight: 400, overflowY: 'auto', overflowX: 'auto', scrollbarWidth: 'none', '&::-webkit-scrollbar': { display: 'none', }, }}>
                                            <Table size="small">
                                                {/* Table Body */}
                                                <TableBody>
                                                    {menuControlData && Array?.isArray(menuControlData) && menuControlData?.length > 0 ? (
                                                        menuControlData?.map((row) => (
                                                            <TableRow key={row.Id}>
                                                                {columns?.map((column) => (
                                                                    <TableCell
                                                                        key={column.field}
                                                                        sx={{
                                                                            fontSize: '10px',
                                                                            whiteSpace: "normal !important",
                                                                            wordWrap: 'break-word',
                                                                            lineHeight: '1.5',
                                                                            textAlign: 'center',
                                                                            width: column.width,
                                                                        }}
                                                                    >
                                                                        {
                                                                            column.field === 'Menu' && row[column.field]
                                                                        }
                                                                        {
                                                                            column.field === 'role' && (
                                                                                <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                                    {row[column.field]
                                                                                        ?.filter((e: any) => e) // remove empty/null
                                                                                        .map((e: any) => roleOption.find(option => option.value === e)?.label)
                                                                                        .filter((label: string | undefined) => !!label)
                                                                                        .join(", ")
                                                                                    }
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {
                                                                            // column.field === 'user' && (
                                                                            //     <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
                                                                            //         {row[column.field]
                                                                            //             ?.filter((e: any) => e) // remove empty/null
                                                                            //             .map((e: any) => userOption.find(option => option.label.toLowerCase() === e.toLowerCase())?.label)
                                                                            //             .filter((label: string | undefined) => !!label)
                                                                            //             .join(", ")
                                                                            //         }
                                                                            //     </div>
                                                                            // )
                                                                            // column.field === 'user' && (<span>{row["UserId"]}</span>)
                                                                            column.field === 'user' && (
                                                                                <div
                                                                                    style={{
                                                                                    whiteSpace: "normal",
                                                                                    wordBreak: "break-word",
                                                                                    overflowWrap: "break-word",
                                                                                    textAlign: "center",
                                                                                    fontSize: "11px",
                                                                                    }}
                                                                                >
                                                                                    {row["UserId"]}
                                                                                </div>
                                                                            )
                                                                        }
                                                                        {/* {
                                                                        column.field === 'user' && row.isSelected &&
                                                                        <div className='Table-select'>
                                                                            <FormControl sx={{ m: 1, minWidth: 250, maxWidth: 250 }}>
                                                                                <Select
                                                                                    multiple
                                                                                    value={row[column.field] || []}
                                                                                    onChange={(event) => this.handleChange(event, row, column.field)}
                                                                                    renderValue={(selected) => selected.map((e: any) => userOption.find(option => option?.label === e.toLowerCase())?.label).toString()}
                                                                                >
                                                                                    {userOption?.map((option) => (
                                                                                        <MenuItem key={option.label} value={option.label}>
                                                                                            <ListItemText primary={option.label} />
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            </FormControl>
                                                                        </div>
                                                                    } */}
                                                                    </TableCell>
                                                                ))}
                                                                <TableCell sx={{ textAlign: "center", width: '200px' }}>
                                                                    <IconButton
                                                                        onClick={() => {
                                                                            this.setState({
                                                                                selectedRow: { ...row, isSelected: true },
                                                                                isModalOpen: true
                                                                            });
                                                                        }}
                                                                        size="small"
                                                                    >
                                                                        <EditIcon fontSize="small" />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    ) : (<TableRow>
                                                        <TableCell colSpan={columns.length + 1} align="center" sx={{
                                                            fontSize: '14px',
                                                            fontWeight: 500,
                                                            color: 'gray',
                                                            padding: '20px',
                                                            borderBottom: 'none',
                                                        }}>
                                                            No records to display
                                                        </TableCell>
                                                    </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </Box>
                                    </TableContainer>
                                </Box>
                            </Paper>
                        </div>
                    </GridTable>

                    {/* MenuControlModal */}
                    <Modal
                        open={isModalOpen}
                        onClose={() => this.setState({ isModalOpen: false })}
                    >
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            bgcolor: 'background.paper',
                            p: 3,
                            borderRadius: 2,
                            boxShadow: 24,
                            width: 400
                        }}>
                            <p><b>Assign Access:</b> {selectedRow?.Menu}</p><br/>
                            {/* Role Dropdown */}
                            <span style={{fontSize: "15px"}}>Select Roles:</span>
                            <FormControl size="small" sx={{ mb: 2, pt: 1, width: 350 }}>
                                <Select
                                    multiple
                                    size="small"
                                    open={this.state.roleDropdownOpen}
                                    onClose={() => this.setState({ roleDropdownOpen: false })}
                                    onOpen={() => this.setState({ roleDropdownOpen: true })}
                                    value={selectedRow?.role || []}
                                    onChange={(event) => {
                                        const updated = { ...selectedRow, role: event.target.value };
                                        this.setState({
                                            selectedRow: updated,
                                            roleDropdownOpen: false,
                                        });
                                    }}
                                    renderValue={(selected) => (
                                        <div
                                            style={{
                                                height: "50px",
                                                overflowY: "auto",
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                            }}
                                        >
                                            {selected
                                                .map((e: any) => roleOption.find((option) => option.value === e)?.label)
                                                .filter(Boolean)
                                                .join(", ")}
                                        </div>
                                    )}
                                    sx={{
                                        fontSize: "0.8rem",
                                        "& .MuiSelect-select": {
                                            py: 0.5,
                                            px: 1,
                                            height: "50px",
                                            display: "flex",
                                            alignItems: "flex-start",
                                            flexDirection: "column",
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 250,
                                                width: 200,
                                            },
                                        },
                                    }}
                                >
                                    {roleOption?.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}
                                            sx={{
                                                fontSize: "0.8rem",
                                                minHeight: "28px",
                                                "&.Mui-selected": { backgroundColor: "#80808059" },
                                                "&.Mui-selected:hover": { backgroundColor: "#6e6e6e59" },
                                            }}
                                        >
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>

                            {/* User Dropdown */}
                            <span style={{fontSize: "15px"}}>Enter User Mails:</span>
                            <FormControl size="small" sx={{ mb: 2, width: 350 }}>
                                {/* <Select
                                    multiple
                                    size="small"
                                    value={selectedRow?.user || []}
                                    onChange={(event) => {
                                        const updated = { ...selectedRow, user: event.target.value };
                                        this.setState({ selectedRow: updated });
                                    }}
                                    renderValue={(selected) => {
                                        const selectedArray = selected as string[];
                                        return (
                                            <textarea
                                                readOnly
                                                style={{
                                                    width: "100%",
                                                    fontSize: "0.8rem",
                                                    padding: "4px",
                                                    overflowY: "auto",
                                                    border: "1px solid #ccc",
                                                    background: "transparent",
                                                    resize: "none",
                                                    height: "80px",
                                                }}
                                                value={selectedArray
                                                    .map((e) => userOption.find((option) => option.label.toLowerCase() === e.toLowerCase())?.label)
                                                    .filter(Boolean)
                                                    .join(", ")}
                                            />
                                        );
                                    }}
                                    sx={{
                                        fontSize: "0.8rem",
                                        "& .MuiSelect-select": { py: 0.5, px: 1 },
                                    }}
                                    MenuProps={{
                                        PaperProps: { sx: { maxHeight: 250, width: 200 } },
                                    }}
                                >
                                    {userOption?.map((option) => (
                                        <MenuItem
                                            key={option.label}
                                            value={option.label}
                                            sx={{
                                                fontSize: "0.8rem",
                                                minHeight: "28px",
                                                "&.Mui-selected": { backgroundColor: "#80808059" },
                                                "&.Mui-selected:hover": { backgroundColor: "#6e6e6e59" },
                                            }}
                                        >
                                            <ListItemText primary={option.label} />
                                        </MenuItem>
                                    ))}
                                </Select> */}
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    multiline
                                    minRows={4}
                                    placeholder="Enter emails with comma separation"
                                    value={selectedRow?.UserId || ''}
                                    onChange={(event) => {
                                        const newValue = event.target.value.split(',').map(v => v.trim()).filter(v => v);
                                        const updated = { ...selectedRow, user: newValue, UserId: (event?.target?.value|| "") };
                                        this.setState({ selectedRow: updated });
                                    }}
                                    sx={{
                                        width: 350,
                                        mb: 2,
                                        fontSize: '12px',
                                        '& .MuiOutlinedInput-input': {
                                        fontSize: '12px',
                                        },
                                        '& .MuiOutlinedInput-notchedOutline legend': {
                                        fontSize: '12px',
                                        },
                                        '& .MuiOutlinedInput-root': {
                                        '& fieldset': {
                                            borderColor: '#ccc',
                                        },
                                        '&:hover fieldset': {
                                            borderColor: '#1976d2',
                                        },
                                        '&.Mui-focused fieldset': {
                                            borderColor: '#1976d2',
                                        },
                                        },
                                        '& textarea::placeholder': {
                                        color: '#999',
                                        fontStyle: 'italic',
                                        opacity: 1,
                                        fontSize: '12px'
                                        }
                                    }}
                                />
                            </FormControl>

                            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
                                <button
                                    onClick={() => this.setState({ isModalOpen: false })}
                                    style={{ padding: "5px 15px" }}
                                >
                                    Cancel
                                </button>
                                <button
                                    style={{ padding: "5px 15px", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px" }}
                                    onClick={async () => {
                                        this.setState(
                                            (prevState: any) => ({
                                                menuControlData: prevState.menuControlData.map((r: any) =>
                                                    r.Id === this.state.selectedRow.Id ? this.state.selectedRow : r
                                                ),
                                                isModalOpen: false,
                                            }),
                                            async () => {
                                                await this.updateRoleForUser();
                                            }
                                        );
                                    }}
                                >
                                    Save
                                </button>
                            </Box>
                        </Box>
                    </Modal>
                </div>
                <Snackbar
                    open={snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <Alert severity={snackbarSeverity} onClose={this.handleCloseSnackbar}>
                        {snackbarMessage}
                    </Alert>
                </Snackbar>
            </>
        )
    }
}
